import React, {Component} from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';



class LoadingBars extends Component {
    state = {
        isStillLoading: true,
    }

    componentDidUpdate() {
        if (this.props.progress >= 100 && this.state.isStillLoading) {
            //this.timer = setTimeout(this.failLoading, 120000)
            this.setState({
                isStillLoading: false
            })
        }
    }

    componentWillUnmount = () => {
      clearTimeout(this.timer)
    }

    failLoading = () => {
        this.setState({
            progress: 'Model Failed to Load'
        }, () => {
            this.props.throwError()
        })
    }

    render () {
        return <div className="max-width">
            <LinearProgress variant="determinate" value={this.props.progress} />
            <p style={{ textAlign: "center" }}>{this.state.progress ? this.state.progress : `${Math.round(this.props.progress)}%` }</p>
        </div>
}
}

export default LoadingBars